import { FulfilmentMethodTrackingData, trackPickupWarehouseChange } from "@DSG/Common/DSGTracking";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    UpdateSessionWithResultApiParameter,
    getSession as getSessionApi,
    updateSessionWithResult,
} from "@insite/client-framework/Services/SessionService";
import {
    PopulateApiParameter,
    UpdateSession,
    chain,
} from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";

type ChangeCustomerContextParameters = Parameters<typeof PopulateApiParameter>[0];

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExt);
function PopulateApiParameterExt(props: ChangeCustomerContextParameters) {
    props.apiParameter = {
        session: {
            customerWasUpdated: false,
            shipToId: props.parameter.shipToId,
            billToId: props.parameter.billToId,
            fulfillmentMethod: props.parameter.fulfillmentMethod,
            pickUpWarehouse: props.parameter.pickUpWarehouse,
        },
    };
}
replaceInChain(chain, UpdateSession, UpdateSessionExt);
async function UpdateSessionExt(props: ChangeCustomerContextParameters) {
    const newApiParameter: UpdateSessionWithResultApiParameter = { ...props.apiParameter };
    if (props.apiParameter.session.billToId) {
        newApiParameter.session.billTo = {
            id: props.parameter.billToId,
            isDefault: props.parameter.isDefault,
        } as BillToModel;
    }
    if (props.apiParameter.session.shipToId !== undefined) {
        newApiParameter.session.shipTo = { id: props.parameter.shipToId } as ShipToModel;
    }

    const result = await updateSessionWithResult(newApiParameter);
    if (result.successful) {
        const fulfilMentMethodChange = {
            event: "form_submit",
            form_action: "submit",
            form_category: "preferences",
            form_name: "fulfillment options",
            form_type: "settings",
            form_selections: [
                {
                    form_field_name: "fulfillment option",
                    form_field_value: props.parameter.fulfillmentMethod,
                },
                {
                    form_field_name: "pickup branch location",
                    form_field_value: props.parameter.pickUpWarehouse?.description,
                },
            ],
        } as FulfilmentMethodTrackingData;
        trackPickupWarehouseChange(fulfilMentMethodChange);
        props.apiResult = await getSessionApi({});
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
}
